// extracted by mini-css-extract-plugin
export var checkbox = "_7p-0";
export var circle = "_7p-3";
export var horizontalContainer = "_7p-7";
export var sm = "_7p-5";
export var switch0 = "_7p-2";
export var switchDisabled = "_7p-8";
export var switchEnabled = "_7p-1";
export var textSwitchContainer = "_7p-9";
export var textSwitchOption = "_7p-a";
export var textSwitchOptionSelected = "_7p-b";
export var verticalContainer = "_7p-6";
export var xs = "_7p-4";